import React from "react";
import axios from 'axios';
import { Container, Row, Col } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import Button from "@material-ui/core/Button";
import  api from '../common/api';
import  MediaFile from '../common/MediaFile';
import LinearProgress from '@material-ui/core/LinearProgress';
import WorkOrderBasicData from '../common/work-orders/BasicData'
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import ViewIcon from '@material-ui/icons/Visibility';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class WorkOrderImport extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			loaded: false,
		    backdrop: false,
			loading: false,
			dialogOpen: false,
			work_order_types:[{}],
			work_order_internal_code_types:[{}],
			work_order_origins:[{}],
      		work_order:{},
			snackbar:{open:false, severity: '',message:''},
      		files:[],
      		rows_inserted:[]
		}
  	}

  	async componentDidMount(){
    	await this.getDropdowns();
  	}

    getDropdowns = async () => {
	    let self = this
	    const token = localStorage.getItem('userToken')
	    await axios.get(api.dropdowns().ot(),
    		{headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
	      		var res = response.data
	      		var work_order_types = res.work_order_types
	      		var work_order_origins = res.work_order_origins
	      		var work_order_expense_types = res.work_order_expense_types
	      		var task_action_types = res.work_order_task_actions_types
	      		var iva_conditions = res.iva_conditions
	      		var work_order_relation_types = res.work_order_relation_types
	      		var work_order_internal_code_types = res.work_order_internal_code_types
	      		this.setState({work_order_types: work_order_types, work_order_origins:work_order_origins, task_action_types:task_action_types, work_order_expense_types:work_order_expense_types, work_order_relation_types: work_order_relation_types, iva_conditions: iva_conditions, work_order_internal_code_types:work_order_internal_code_types })
	      })
	      .catch(function (error) {
	    	console.log(error)
	    })
    }


  	handleDownloadTemplate = () => {
		window.location.href = api.work_order_import_template
  	}

	handleUploadFile = (file, meta_data) => {
		var files_state = this.state.files
		var file = {file: file, meta_data: meta_data}
		files_state.push(file)
		this.setState({files: files_state})
	}	

    handleSnackbar = (e) => {
    	e.preventDefault()
    	var snackbar = this.state.snackbar
    	snackbar.open = !snackbar.open
    	this.setState({snackbar: snackbar})
    }

	handleCloseBackdrop = () => {
		var backdrop = !this.state.backdrop
		this.setState({backdrop: backdrop})
	}

	handleChange = (e) => {
		if (e.target.name === 'work_order_id'){
			this.setState({work_order_id: e.target.value})
		}
	}

	handleSearchWorkOrder = () => {
		var snackbar = this.state.snackbar
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.get(api.work_order().get(this.state.work_order_id, true),
    		{headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
	      		var res = response.data
	      		var state = this.state
	      		var work_order = {}
	      		work_order.state = res.state
	      		work_order.hansa_code = res.hansa_code
	      		work_order.id = res.id
	      		work_order.reason = res.reason
	      		work_order.internal_code = res.internal_code
	      		work_order.internal_code_type = res.internal_code_type
	      		work_order.work_order_expense_type_id = res.work_order_expense_type_id
	      		work_order.work_order_origin_id = res.work_order_origin_id
	      		work_order.work_order_type_id = res.work_order_type_id 
	      		work_order.contract_id = res.contract_id
	      		work_order.client_id = res.client_id
	      		work_order.is_approved = res.is_approved
	      		this.setState({work_order: work_order})
	      })
	      .catch(function (error) {
	      	snackbar.message = 'La OT no está cerrada o no existe.'
	      	snackbar.open = true
	      	snackbar.severity = 'error'
	      	self.setState({snackbar: snackbar})
	    	console.log(error)
	    })

	}


	handleSubmit = (e) => {
		this.setState({loading: true})
    	e.preventDefault();
	    var formData = new FormData();
		var i = 0;
	    formData.set("work_order_id", this.state.work_order_id);
		if (this.state.files){
			this.state.files.map((val, idx) => {
				if (val.file !== '' && val.file !== undefined){
					formData.set("import", val.file[0])
					i++;
				}	
			})
		}
	    var errors =[]
	    var rows_inserted = []
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.post(api.work_order().import(),
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
		  		this.setState({excel_loaded:true, message: response.data.message, rows_inserted: response.data.rows_inserted })
				this.setState({loading: false})

	      })
	      .catch(function (error) {
				var promise = new Promise(function(resolve, reject) {
					resolve(error.response.data);
					errors = error.response.data
					rows_inserted = error.response.data.rows_inserted
		  		});
				self.setState({errors: errors, files:[], excel_loaded:true, rows_inserted: rows_inserted})		  		
				self.setState({loading: false})
	    })
	}

  	render(){
	    const handleRedirect = id => () => {
	      window.location.href='/work-orders'
	    }
	    var messages = []
	    if (this.state.errors){
			if (this.state.errors.message){
				var errors = Object.values(this.state.errors.message)
				errors.map((val,idx)=>{
					var rows = Object.keys(val)
					rows.map((val2,idx2)=>{
						var fields = Object.values(val[val2])
						fields.map((val3,idx3)=>{
							var message = 'La linea ' + val2 + ': '+val3[0]
							messages.push(message)
							/*return (
								<div style={{color: 'red'}}>Línea {row}: {val2[0]}</div>
							)*/
						})
  
					})
  
				})
			} else {
				var errors = Object.values(this.state.errors.errors)
				errors.map((val,idx)=>{
					messages.push(val)
				})
			}
	    }

	    if (this.state.rows_inserted){
	    	var rows_inserted = this.state.rows_inserted
	    	rows_inserted.map((val,idx)=>{
	    		var message = '<a target="_blank" href="/work-order/' + val.id + '">OT: ' + val.id + '</a> - Patente: '+ val.plate
  				messages.push(message)
	    	})
	    }

  		return(
	         <Container fluid className="main-content-container px-4 pb-4">
				<Snackbar open={this.state.snackbar.open} onClose={this.handleSnackbar}>
					<Alert onClose={this.handleSnackbar} severity={this.state.snackbar.severity}>
					  {this.state.snackbar.message}
					</Alert>
				</Snackbar>

	            <Row noGutters className="page-header pt-4">
	              <PageTitle lg="12" title="Alta masiva de OT" className="text-lg-left" />
	            </Row>
				<Row>
				<Col md="12">
				  <React.Fragment>
			      <div className="mt-2">
	              {(this.state.loading)?
	                 <LinearProgress /> 
	              :
	              	(this.state.excel_loaded)
	              	?
		              	(messages) ?
		              		messages.map((val,idx2)=>{
		              			return (
									<div dangerouslySetInnerHTML={{ __html: val }}  className="mt-1"/>		              				
		          				)
		              		})

		              	:
		              		''
		            :
						<React.Fragment>
							<TextField
								id="work_order_id"
								value={this.state.work_order_id}
								onChange={this.handleChange}
								type="text"
								required
								name="work_order_id"
								margin="normal"
								className="m-0 p-0 mr-2 my-2"
								InputLabelProps={{
									shrink: true
								}}
					          	InputProps={{
						            startAdornment: <InputAdornment position="start" ><a className={(this.state.work_order.id > 0 ) ? 'd-block' : 'd-none'} href={"/work-order/"+this.state.work_order.id} target="_blank"><ViewIcon /></a><Typography variant="caption"># OT</Typography></InputAdornment>,
						            endAdornment: <InputAdornment position="start" ><SearchIcon onClick={this.handleSearchWorkOrder}/></InputAdornment>,
								}}
								inputProps={{style:{fontSize: '0.75rem'}}}
							/>
							{(this.state.work_order.id > 0)
								?
									<WorkOrderBasicData work_order_origins={this.state.work_order_origins} work_order_types={this.state.work_order_types} work_order={this.state.work_order} work_order_expense_types={this.state.work_order_expense_types}	vehicle_fleet_owner={this.state.vehicle} work_order_internal_code_types={this.state.work_order_internal_code_types}/>
								:
									''
							}
							<MediaFile onChange={this.handleUploadFile} title="Agregar excel" width={"15rem"} height={"2rem"}  meta_data="ot_duplicadas" />
							<Button disabled={(this.state.work_order.id > 0 && this.state.files.length > 0 && !this.state.loading) ? false : true} className="mt-2 mr-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={this.handleSubmit}>
								{(this.state.loading)
								?
									<span><CircularProgress /> Cargando...</span>
								:
									<span>Cargar</span>
								}
							</Button>
						</React.Fragment>
				  }			  
				<Button className="mt-2 mr-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={(e) => {this.handleDownloadTemplate()}}>Descargar Template</Button>
				<Button className="mt-2" variant="contained" color="secondary" size="small" style={{fontSize: '0.75rem'}} onClick={(e) => {window.location.href='/work-orders'}}>Volver</Button>
				</div>
	            </React.Fragment>
	          </Col>
	        </Row>
            <Backdrop open={this.state.backdrop} onClick={this.handleCloseBackdrop} style={{zIndex: 10000, color: '#3f51b5'}}>
                  <Typography className="ml-2" variant="h5" color="primary">Guardando...</Typography>
            </Backdrop>

	      </Container>

		)
  	}

}
export default WorkOrderImport;
